import { render, staticRenderFns } from "./suBackRecord.vue?vue&type=template&id=2ee4bfee"
import script from "./suBackRecord.vue?vue&type=script&lang=js"
export * from "./suBackRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports